import { JsonValue } from '../../app/json/jsonValue.js';

/**
 * Mutable per-merge transient state shared by IData and IAction handlers.
 */
export abstract class ITransientStore {
    abstract containsKey(key: string): boolean;
    abstract getValue(key: string): JsonValue | null;
    abstract setValue(key: string, value: unknown): void;
}
